import React, { Component } from 'react';
import { Grid, Row } from 'react-bootstrap';
import Header from './components/vheader';
//import Menu from './components/vmenu';
//import Article from './components/varticle';
//import Footer from './components/vfooter';
//import Menudisk from './components/menudisk';

//import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <Grid className="App">
        <Row >
          <Header />
        </Row>
      </Grid>
    );
  }
}
        //  <Menudisk />
export default App;

/*        <Row>
          <Menu />
        </Row>
        <Row>
          <Col sm={12} md={6} lg={6}>
            <Article  />
          </Col>
          <Col sm={12} md={6} lg={6}>
            <Article  />
          </Col>
        </Row>
        <Row>
          <Footer />
        </Row>*/


/*<header className="App-header">
  <img src={logo} className="App-logo" alt="logo" />
  <h1 className="App-title">Welcome to React</h1>
</header>*/



// WEBPACK FOOTER //
// ./src/App.js